import * as ng from 'angular';
import * as _ from 'underscore';
import * as moment from 'moment';

const serverDateFormat = 'YYYY-MM-DDTHH:mm:ss';
export const defaultDateInputFormat = 'MM/DD/YYYY HH:mm A';
const urlRegx = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

export class UtilsService {
   static $inject = ['$q', 'session'];

   constructor(
      private $q:ng.IQService,
      private session
   ) { }

   isValidURL(str:string):boolean {
      return urlRegx.test(str);
   }

   toQuery(obj:any):string {
      // 'true' turns on traditional handling for arrays
      // i.e. {a: [1,2]} => ?a=1&a=2
      return $.param(obj, true);
   }

   generateUniqueId():string {
      return _.times(4, () => {
         return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
      }).join('');
   }

   /**
    * @deprecated use fdate:'date' filter
    */
   formatDate(value:any, format?:string):string {
      if (!value) {
         return '';
      }

      let f = format || 'MMM Do, YYYY';
      let m = moment.isMoment(value) ? value : moment(value);

      return m.format(f);
   }

   private isDate(value:any):boolean {
      return value && value !== ''
         && moment(value, defaultDateInputFormat).isValid();
   }

   toServerDateTime(value:any, inputFormat?:string):string {
      var format = inputFormat || defaultDateInputFormat;
      if (this.isDate(value)) {
         return moment(value, format).format(serverDateFormat);
      }
   }

   toServerMoment(value:string) {
      return moment(value, serverDateFormat);
   }

   getQRUrl(args:{wbid:string, imageOnly?:boolean}):string {
      return `http://${this.session.qrDomain()}/${args.imageOnly ? 'qr/' : ''}${args.wbid}`;
   }

   // TODO move this into api-helper.service
   // call from service create/update methods that need it
   nullifyBlankFields(obj:{}):void {
      for (let key in obj) {
         if (obj[key] === '') {
            obj[key] = null;
         }
      }
   }

   allDaysBetween(startDate:string, endDate:string):any[] {
      let startDay = moment(startDate).startOf('day');
      let endDay = moment(endDate).startOf('day');
      let numDays = endDay.diff(startDay, 'days') + 1;
      return _.times(numDays, (i:number) => {
         return startDay.clone().add(i, 'd');
      });
   }

   isBoolean(val:any):boolean {
      try {
         let bool = $.parseJSON(val.toString().toLowerCase());
         return (bool === 0 || bool === 1 || bool === false || bool === true);
      } catch (err) {
         return false;
      }
   }

   parseBoolean(val:any):boolean {
      if (val === null || typeof(val) == 'undefined') {
         return false;
      }

      if (this.isBoolean(val)) {
         return $.parseJSON(val.toString().toLowerCase());
      } else {
         return false;
      }
   }

   readFileAsDataUrl(file:File):ng.IPromise<string> {
      let deferred = this.$q.defer<string>();

      let reader = new FileReader();

      reader.addEventListener('load', () => {
         deferred.resolve(reader.result as string);
      });

      reader.addEventListener('error', () => {
         deferred.reject();
      });

      reader.readAsDataURL(file);

      return deferred.promise;
   }
}

ng.module('e360')
   .service('utils', UtilsService);
